module.exports = __webpack_public_path__ + "static/media/media.fa476344.jpg";